<script>
import { mapActions } from 'vuex'
import formatDateTime from '@utils/format-date-time'

export default {
  props: {
    report: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    cancelableStatus() {
      return (
        this.report.status.value === 'pending' ||
        this.report.status.value === 'in_progress'
      )
    },
  },

  methods: {
    ...mapActions('reports', ['downloadReport', 'cancelReportFileGeneration']),
    ...{ formatDateTime },

    cancelReport() {
      if (this.cancelableStatus) this.cancelReportFileGeneration(this.report.id)
    },

    checkIfPDF(file) {
      const downloadType = this.report?.name?.endsWith('.pdf')
        ? 'pdfReports'
        : undefined
      this.downloadReport({ link: this.report.file, type: downloadType })
    },
  },
}
</script>

<template>
  <div>
    <b-dropdown-item href="#">
      <b-row class="d-flex justify-content-between">
        <b> {{ report.name }} </b>
        <div
          v-if="report.status.value === 'ready'"
          class="download"
          @click="checkIfPDF"
        >
          <BaseIcon name="download" />
          <b> Download </b>
        </div>
      </b-row>
      <b-row
        :class="
          report.status.value === 'failed'
            ? 'red-text d-flex'
            : 'd-flex justify-content-between'
        "
        @click="cancelReport()"
      >
        <p> {{ report.status.text }} </p>
        <span v-if="report.status.value === 'failed'">
          ({{ report.error_message }})
        </span>
        <p v-if="report.status.value === 'ready'">
          Expires on: {{ formatDateTime(report.expired_at) }}
        </p>
        <p v-if="cancelableStatus"> Cancel </p>
      </b-row>
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
  </div>
</template>

<style lang="scss">
.download {
  color: #004caa;
  &:hover {
    cursor: pointer;
  }
}

.red-text {
  color: red;
}
</style>
